/** Kvalitetsgrind för modellseriesidorna (/modeller/$brand/$serie). */

import { MODELL_SERIER, modellSerieText, type ModellSerie } from "@/data/modell-serier";
import { assessPage, type QualityAssessment } from "../seo-quality";

const cache = new Map<string, QualityAssessment>();

export function assessModellSerie(m: ModellSerie): QualityAssessment {
  const key = `${m.brandSlug}/${m.slug}`;
  const hit = cache.get(key);
  if (hit) return hit;
  const peers = MODELL_SERIER.filter((x) => `${x.brandSlug}/${x.slug}` !== key).map(modellSerieText);
  const result = assessPage(modellSerieText(m), peers, { minWords: 420, minDataPoints: 10 });
  cache.set(key, result);
  return result;
}

export function indexableModellSeriePaths(): string[] {
  return MODELL_SERIER.filter((m) => assessModellSerie(m).passed).map(
    (m) => `/modeller/${m.brandSlug}/${m.slug}`,
  );
}

export { modellSerieText };
